/**
 * Вынос списка референсов из панели: id в буфер и CSV для Excel.
 *
 * CSV — способ «поделиться набором» (корзина у каждого своя): `;` и BOM нужны,
 * чтобы русский Excel открыл файл без мастера импорта и без кракозябр.
 */
import { verdictLabel, type ReferenceItem } from "@/lib/library";

/** «12, 15, 18» — чтобы вставить в чат или в CLI (`--items`). */
export const idsText = (ids: number[]): string => ids.join(", ");

/** `false` — буфера нет (http, старый браузер) или браузер отказал. */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

const cell = (value: string | number): string => `"${String(value).replace(/"/g, '""')}"`;

export function itemsCsv(items: ReferenceItem[], tagNames: ReadonlyMap<number, string>, origin: string): Blob {
  const rows = items.map((i) =>
    [
      i.id,
      i.category_name,
      i.library_name,
      i.verdict ? verdictLabel[i.verdict] : "",
      i.tag_ids.map((t) => tagNames.get(t) ?? String(t)).join(", "),
      i.note ?? "",
      `${origin}/media/${i.asset_path}`,
    ]
      .map(cell)
      .join(";"),
  );
  const head = ["id", "категория", "библиотека", "вердикт", "теги", "заметка", "ссылка"].join(";");
  return new Blob(["\uFEFF" + [head, ...rows].join("\r\n")], { type: "text/csv;charset=utf-8" });
}

/** `references-2026-10-06-12.csv`; дата — локальная, как её видит человек. */
export function csvName(count: number): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  return `references-${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}-${count}.csv`;
}

export function downloadBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
